import React, { FunctionComponent } from 'react';
import { TENANT_ROUTE } from '../../constants';
import CspConfig from './CspConfig';

/**
 * People > Tenant: the CSP configuration pages, kept inside the People section.
 */
const Tenant: FunctionComponent = () => <CspConfig basePath={TENANT_ROUTE} />;

export default Tenant;
